import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-details-list-modal',
  templateUrl: './details-list-modal.component.html',
  styleUrl: './details-list-modal.component.scss',
  standalone: false,
})
export class DetailsListModalComponent {
  @Input() modalTitle: string;
  @Input() dataList: any[];
  @Input() closeButton: string = 'common.closeButton';

  constructor(private _activeModal: NgbActiveModal) {}

  closeModal() {
    this._activeModal.close(true);
  }
}
